module.exports = __webpack_public_path__ + "static/media/ally_pro_2.36285b79.jpg";